export default "__VITE_ASSET__DCVnl6co__"